import React from "react"

export default class CitiesList extends React.Component 
{  
    constructor(props)
    {
        super(props);    
        this.env = this.props.env;        
        this.code = this.props.code;
        this.state = this.props.state;
        this.codes = this.props.codes;
        this.page = this.props.page;
        this.cities = this.props.cities.length > 0 ? this.props.cities : [];      
        this.cities.sort((a,b) => (a.place > b.place) ? 1 : ((b.place > a.place) ? -1 : 0));  
    }

    pickTitle = () =>
    {
        if (this.props.title !== undefined)
        {
            return this.props.title;
        }        
        
        let title = '';
        
        switch(this.page)
        {
            case 'home': case 'pro':          
                        
                title = this.env.site === 'dumpster' ? "Popular Cities for {type}" : "Popular Cities for Demolition Contractors"; 
                
                this.codes.map(ele =>
                {
                    if(ele.code === this.code)
                    {
                        title = title.replace('{type}', ele.name);
                    }
                }) 

                break;
            
            default:        
                title = 'Top {state} Cities for {type}';      
                this.codes.map(ele =>
                {
                    if(ele.code === this.code)
                    {
                        title = title.replace('{type}', ele.name);
                    }
                })   
                
                if(this.code === 'demolition-contractors')
                {
                    title = title.replace('{type}', 'Demolition Contractors');
                }
                
                title = title.replace('{state}', this.props.state.name);
                break;
        }               

        return title;
    }

    more = () =>
    {
        if(this.props.page !== 'home' && this.props.page !== 'pro')
        {                      
            let slug = ''
            
            this.codes.map(code =>
            {
                if(code.code === this.code)
                {                  
                    slug = '/'+code.paths.name;
                }
            }) 
            
            let state = '';

            switch(this.state.slug)
            {
                case 'district-of-columbia':
                    state = 'District_of_Columbia';
                    break;
                
                default:
                    state = this.state.slug.replace(/ /g,'_').replace(/-/g,'_');
                    break;
            }
            
            const link = '/all-cities/'+state+slug;

            return(

                <a className="more" href={link}>More Places</a>

            );
        }
    }

    render()
    {        
        
        if(this.props.hide)
        {
            return(
                <></>
            )
        }
        
        return(

            <section className="section cities-list" style={{background: this.page === 'state' ?  '#e8e8e8' : '#FFFFFF'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h3>{this.pickTitle()}</h3>
                        </div>
                    </div>
                    <ul className="all-cities">
                    {                       
                        this.cities.map((city, index) => 
                        {              
                            let name = this.props.page === 'home' ? city.place : city.place.split(',')[0];

                            return (
                                <li key={index}>
                                    <a href={'/'+city.url}>{name}</a>
                                </li>
                            )
                        })
                    }
                    </ul>
                    
                    {this.more()}
                </div>
            </section>

        )
    }
}